import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from "@/components/ui/card";
import { Building2, MapPin, Star, Building } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BarChart3, User, Phone, Mail, Package } from "lucide-react";
import { Carrier } from "@/api/broker/getCarriers";
import { Badge } from "@/components/ui/badge";

type Props = {
  selectedCarrier: Carrier;
};

export const CarrierInfo = ({ selectedCarrier }: Props) => {
  return (
    <div className="lg:col-span-2 m-4">
      {selectedCarrier ? (
        <div className="space-y-6">
          {/* Tabbed Content */}
          <Tabs defaultValue="overview" className="w-full ">
            <TabsContent value="overview" className="space-y-6">
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                {/* Performance Metrics */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <BarChart3 className="h-5 w-5" />
                      Performance Metrics
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center p-4 bg-green-50 rounded-lg">
                        <div className="text-2xl font-bold text-green-600">
                          {selectedCarrier.totalLoads}
                        </div>
                        <div className="text-sm text-gray-600">Total Loads</div>
                      </div>
                      <div className="text-center p-4 bg-purple-50 rounded-lg">
                        <div className="text-2xl font-bold text-purple-600">
                          98%
                        </div>
                        <div className="text-sm text-gray-600">
                          On-Time Rate
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                {/* Contact Information */}
                <Card>
                  <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                      <User className="h-5 w-5" />
                      Contact Information
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4 h-[calc(60vh-320px)] overflow-y-auto">
                    <div className="">
                      <div className="text-sm font-medium text-gray-500">
                        Company Name
                      </div>
                      <div className="flex items-start gap-2">
                        <div className="text-md">
                          <Building className="h-4 w-4" />
                        </div>
                        <div className="text-sm text-gray-600">
                          {selectedCarrier.companyName}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-gray-500">
                        Phone
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-2">
                          <Phone className="h-4 w-4" />
                        </div>
                        <div className="text-sm text-gray-600">
                          {selectedCarrier.contactPhone || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-gray-500">
                        Email
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-2">
                          <Mail className="h-4 w-4" />
                        </div>
                        <div className="text-sm text-gray-600">
                          {selectedCarrier.contactEmail || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-gray-500">
                        Address
                      </div>

                      <div className="flex items-start gap-2">
                        <MapPin className="h-4 w-4 mt-0.5" />
                        <div className="text-sm text-gray-600">
                          {selectedCarrier.address}
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      ) : (
        <Card className="h-full flex items-center justify-center">
          <CardContent>
            <div className="text-center text-gray-500">
              <Building2 className="h-12 w-12 mx-auto mb-4 text-gray-300" />
              <p>Select a carrier to view details</p>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
